import type {ReactElement, ReactNode} from 'react';
import React from 'react';
import {Option} from '@Components/contextual-menu/components/option';
import type {ButtonItemsStorageType} from '@Components/contextual-menu/components/button-items';
import {ButtonItems} from '@Components/contextual-menu/components/button-items';

interface ContextualMenuButtonOptionProps {
  id: string;
  className?: string;
  label?: string;
  data: ButtonItemsStorageType;
  isInlineOption?: boolean;
  containerClassName?: string;
  children?: ReactNode;
  tag?: ReactNode;
  subOptionClassName?: string;
  subOptionHasOverflow?: boolean;
}

export function ContextualMenuButtonOption({
  children = null,
  className = '',
  containerClassName = '',
  subOptionHasOverflow = false,
  ...props
}: ContextualMenuButtonOptionProps): ReactElement {
  return (
    <Option
      tag={props.tag}
      key={props.id}
      label={props.label}
      className={className}
      optionControl={<ButtonItems data={props.data} containerClassName={containerClassName} isInlineOption={props.isInlineOption} />}
      subOptionClassName={props.subOptionClassName ?? ''}
      subOptionHasOverflow={subOptionHasOverflow}
    >
      {children}
    </Option>
  );
}
